import React from 'react';
import { RiAddFill, RiDeleteBinLine, RiPhoneLine } from 'react-icons/ri';
import { getError } from '../../helperFunctions';
import MultiSelectDropdown from '../../../components/MultiSelectDropdown';
import {
  Button,
  HelperText,
  IconButton,
  Label,
  TextInput,
} from '../../../components/UiComponents/Ui';

import { useQuery } from '@tanstack/react-query';
import { getCountryCodes } from '../../../Actions/commonActions';

export const PhoneField = ({ supplierData, onChange, formErrors }) => {
  const { data, isLoading, error } = useQuery({
    queryKey: ['country-codes'],
    queryFn: getCountryCodes,
  });
  const options = (data || []).map((c) => ({
    label: `${c?.icon} +${c?.countryCode} - ${c?.label}`,
    value: `+${c?.countryCode}`,
  }));
  const selected = options.find(
    (d) => d.value === supplierData?.phone?.countryCode,
  );

  const codeError = getError(['phone', 'countryCode'], formErrors);
  const numberError = getError(['phone', 'number'], formErrors);

  return (
    <div className="space-y-[6px]">
      <Label>Contact Number</Label>
      <div className="flex items-start gap-[10px]">
        <div className="w-[190px] shrink-0">
          <MultiSelectDropdown
            options={options}
            disabled={Boolean(isLoading || error)}
            dropdownText="Country Code"
            width="190px"
            search
            selected={[
              {
                label: selected?.label || '',
                value: supplierData?.phone?.countryCode || '',
              },
            ]}
            setSelected={(e) => {
              const value = e;
              console.log('value=>', value);

              onChange(['phone', 'countryCode'], value?.[0]?.value);
            }}
          />
        </div>
        <div className="w-full">
          <TextInput
            type="number"
            placeholder="Enter 10 digit number"
            startIcon={<RiPhoneLine size={16} className="text-gray-500" />}
            value={supplierData?.phone?.number || ''}
            error={numberError}
            onChange={(e) => onChange(['phone', 'number'], e.target.value)}
          />
        </div>
      </div>
      {!!codeError && <HelperText>{codeError}</HelperText>}
      {!!numberError && <HelperText>{numberError}</HelperText>}
    </div>
  );
};

export const BusinessIdFields = ({
  supplierData,
  onChange,
  formErrors,
  onAdd,
  onRemove,
}) => (
  <div className="space-y-[6px]">
    <Label>Business IDs</Label>

    {supplierData?.companyCodes?.map((item, index) => {
      const labelError = getError(['companyCodes', index, 'label'], formErrors);
      const valueError = getError(['companyCodes', index, 'value'], formErrors);
      return (
        <div className="flex w-full items-start gap-[10px]" key={index}>
          <div className="w-1/2">
            <TextInput
              placeholder="ID Name"
              value={item?.label || ''}
              required
              inputProps={{ minLength: 3, maxLength: 24 }}
              error={labelError}
              onChange={(e) =>
                onChange(['companyCodes', index, 'label'], e.target.value)
              }
            />
            {!!labelError && <HelperText>{labelError}</HelperText>}
          </div>
          <div className="w-1/2">
            <TextInput
              placeholder="ID Value"
              value={item?.value || ''}
              required
              inputProps={{ minLength: 3, maxLength: 50 }}
              error={valueError}
              onChange={(e) =>
                onChange(['companyCodes', index, 'value'], e.target.value)
              }
            />
            {!!valueError && <HelperText>{valueError}</HelperText>}
          </div>
          {onRemove && (
            <IconButton
              aria-label="Remove ID"
              variant="soft"
              intent="error"
              onClick={() => onRemove(index)}
            >
              <RiDeleteBinLine size={16} />
            </IconButton>
          )}
        </div>
      );
    })}

    {onAdd && (
      <Button
        type="button"
        variant="soft"
        onClick={onAdd}
        startIcon={<RiAddFill size={20} />}
      >
        Add More IDs
      </Button>
    )}
  </div>
);
